import React, { useContext } from "react";
import { ProcedureType, TScreen } from "api/type";

// Import Contexts
import ScreenContext from "contexts/screen";

// Import Components
import {
  NormalText,
  PrimaryButton,
  TitleBar,
  UploadPhoto,
} from "components/index";
import {
  isFaceProcedure,
  isTorsoProcedure,
} from "utils/isFaceBodyOrTorsoProcedure";

// Pose URLs
const torsoFrontPoseUrl =
  "https://clinic-os.com/flow-assets/body-scanner-ai/breast-pose-bold/breast-procedures-transparent-front-bold.png";
const bodyFrontPoseUrl =
  "https://clinic-os.com/flow-assets/body-scanner-ai/body-pose-bold/body-procedures-transparent-front-bold.png";
const bodyBackPoseUrl =
  "https://clinic-os.com/flow-assets/body-scanner-ai/body-pose-bold/body-procedures-transparent-back-bold.png";
const faceFrontPoseUrl =
  "https://clinic-os.com/flow-assets/body-scanner-ai/face-pose-bold/face-procedures-transparent-front-bold.png";
const getImagePoseUrl = (selectedProcedure: ProcedureType) => {
  if (selectedProcedure === ProcedureType.BUTTOCK_AUGMENTATION)
    return bodyBackPoseUrl;
  if (selectedProcedure === ProcedureType.BBL) return bodyBackPoseUrl;
  if (isFaceProcedure(selectedProcedure)) return faceFrontPoseUrl;
  if (isTorsoProcedure(selectedProcedure)) return torsoFrontPoseUrl;
  return bodyFrontPoseUrl;
};

type ScreenUploadPhotoProps = {
  selectedProcedure: ProcedureType | null;
  handleSaveImageUrlOrBlob: (imageUrlOrBlob: Blob | string) => void;
};

const ScreenUploadPhoto: React.FC<ScreenUploadPhotoProps> = ({
  selectedProcedure,
  handleSaveImageUrlOrBlob,
}) => {
  // Context
  const setScreen = useContext(ScreenContext)[1];

  // Local State
  const [uploadedPhoto, setUploadedPhoto] = React.useState<Blob | null>(null);

  // Handlers
  const handleSaveImageBlob = (imageBlobOrNull: Blob | null) => {
    setUploadedPhoto(imageBlobOrNull);
  };

  if (!selectedProcedure) return null;

  return (
    <div className="screen-container">
      <TitleBar
        name={"Upload your photo"}
        onClickBackButton={() =>
          setScreen(TScreen.PHOTO_UPLOAD_INSTRUCTIONS_SCREEN)
        }
      />
      <NormalText
        textContent={
          "Follow the guideline image before taking your photos to receive the best results."
        }
      />
      <div style={{ margin: "auto", width: "99%" }}>
        <UploadPhoto
          poseUrl={getImagePoseUrl(selectedProcedure)}
          storePhoto={handleSaveImageBlob}
        />
      </div>
      <PrimaryButton
        onClick={() => {
          if (!uploadedPhoto) return;
          setScreen(TScreen.SIMULATION_VIEW_SCREEN);
          handleSaveImageUrlOrBlob(uploadedPhoto);
        }}
        disabled={!uploadedPhoto}
        fullWidth
        text={"Upload photos"}
      />
    </div>
  );
};

export default ScreenUploadPhoto;
